import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/Feeding.module.css';
import * as LIB from '../../lib/common';
import parse from 'html-react-parser';
const Feeding = ({ listData, typeName }) => {


  const renderArticle = (article, index) => {
    let imgPath = LIB.getBasepath(`/images/topic/03a.jpg`);
    return (
      <>
        {/* <Col xs={12} md={2} lg={2} id='testing'>
          <Image
            src={imgPath}
            layout="responsive"
            height={230}
            width={400}
            alt="圖片"
            className={styles.feedingImg}
          />
        </Col> */}
        <Col xs={12} md={12} lg={12}>
          <div className={styles.title} onClick={() => { LIB.viewArticle(article.id, article.title, '_blank') }}>{article.title}</div>
          <div className={styles.postDate}>{article.post_date.substring(0, 10)} | 瀏覽 : {article.count} | 回應 : {article.msg}</div>
          <div className={styles.content}>{parse(article.content)}</div>
        </Col>
      </>
    );
  }

  if(listData){
    return (
      <Container fluid style={{ padding:0,marginTop:10 }}>
        {listData && listData.map((article, index) => (
          <Row key={index} className={styles.feedingHolder}>
            {renderArticle(article, index + 1)}
          </Row>
        ))
        }
      </Container>
    );
  }

  return(<></>);
}


export default Feeding;